import { validate, isRequired, AgreementCheck, isMaxNumber, isMinNumber } from '../../../services/validator'
import { numberWithSpaces } from "../../../helpers";

import { METHODS } from './constants'

function getRules() {
  return {
    amount: [
      isRequired,
      (val) => isMinNumber(val, 100, 'Минимальная сумма пополнения 100 ₽'),
      (val) => isMaxNumber(val, 1000000, `Максимальная сумма пополнения ${numberWithSpaces(1000000)} ₽`)
    ],
    method: [isRequired],
    isAgree: [AgreementCheck]
  }
}

export function validateCreatePaymentForm(values) {
  return validate(values, getRules())
}



// WEBPACK FOOTER //
// ./src/modules/home/pricing/validate.js